module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.2a3d13e3.ttf";